var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "240px",
    height: "132px",
    viewBox: "0 0 240 132",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "buy-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M59.6336482,112.086915 L60.3411439,111.811777 C62.9175869,110.809827 63.374016,108.464348 61.3682632,106.570026 L50.6317368,96.4299737 C48.6291268,94.5386198 47,95.2394595 47,98.0019727 L47,111.998027 C47,114.76369 49.0858409,116.18884 51.6588561,115.188223 L52.1769728,114.986733 L53.1488061,117.392105 C53.7667117,118.921475 55.5174877,119.667323 57.054549,119.04631 L58.9058283,118.298345 C60.4474062,117.675507 61.1862978,115.929857 60.5662769,114.395252 L59.6336482,112.086915 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 15.6178771,
    height: 23.8976548,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 48,
    height: 31,
    rx: 6
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: -2,
    y: -2,
    width: 52,
    height: 35
  }, /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 52,
    height: 35,
    fill: "white"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 48,
    height: 31,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop---reserva-inicio",
    transform: "translate(-264.000000, -551.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "buy-icon",
    transform: "translate(264.000000, 551.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-7",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 240,
    height: 132
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(84.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    fill: "#C80032",
    opacity: 0.100000001,
    x: 0,
    y: 10,
    width: 72,
    height: 105,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    fill: "#C80032",
    opacity: 0.100000001,
    x: 13,
    y: 80,
    width: 47,
    height: 21,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    fill: "#C80032",
    opacity: 0.100000001,
    x: 12,
    y: 28,
    width: 48,
    height: 8,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    fill: "#C80032",
    opacity: 0.100000001,
    x: 12,
    y: 42,
    width: 48,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    fill: "#C80032",
    opacity: 0.100000001,
    x: 12,
    y: 51,
    width: 48,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    fill: "#C80032",
    opacity: 0.100000001,
    x: 12,
    y: 60,
    width: 48,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    fill: "#C80032",
    opacity: 0.100000001,
    x: 12,
    y: 69,
    width: 48,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    stroke: "#2E2B2B",
    mask: "url(#mask-2)",
    strokeWidth: 4,
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(55.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-11"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#FFFFFF",
    mask: "url(#mask-4)",
    strokeWidth: 4,
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#0073DC",
    mask: "url(#mask-5)",
    strokeWidth: 4,
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#0073DC",
    x: 0,
    y: 16,
    width: 48,
    height: 8
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyIcon);
export default __webpack_public_path__ + "static/media/buy-icon.aefbb25b1ff02c6c9acf9645bf9feec1.svg";
export { ForwardRef as ReactComponent };